import { combineReducers } from 'redux'
import * as actions from '../actions'
import booleanReducer from '../utils/booleanReducer'

export const initialState = {
  isFetching: false,
  items: [],
}

const isFetching = booleanReducer({
  defaultState: initialState.isFetching,
  trueTypes: [actions.GET_MARKETS_REQUEST],
  falseTypes: [actions.GET_MARKETS_SUCCESS, actions.GET_MARKETS_FAILURE],
})

const items = (state = initialState.items, { type, payload }) => {
  if (type === actions.GET_MARKETS_SUCCESS) {
    return [...payload]
  }
  return state
}

export default combineReducers({
  isFetching,
  items,
})



// WEBPACK FOOTER //
// ./src/reducers/markets.js